import i18next from 'i18next'
import * as yup from 'yup'

export const societyAdminCreateSchema = yup
  .object({
    userIds: yup
      .array(yup.string())
      .min(1, i18next.t('createUpdateAdminForm.error.minItems'))
      .required(),
  })
  .required()
